module.exports={"app.title":"Manu Pacheco #developer"};